import { render } from "./user-info.vue?vue&type=template&id=f7b87e16&scoped=true&ts=true"
import script from "./user-info.vue?vue&type=script&lang=ts"
export * from "./user-info.vue?vue&type=script&lang=ts"

import "./user-info.vue?vue&type=style&index=0&id=f7b87e16&scoped=true&lang=scss"

import exportComponent from "/data/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
export default /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f7b87e16"]])